<input type="text" id="scriptHelper" class="sr-only">
<div class="main-content" *ngIf="!profile">
  <div class="loader"></div>
</div>
<div class="app-loading" *ngIf="loading">
  <div class="logo"></div>
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
  <p class="app-loading-message">{{loadingMessage}}</p>
</div>
<main class="container-api" *ngIf="profile">
  <header class="header-api">
    <h4>Acesso à API do Polen</h4>
    <p>Utilize esses dados para implementações personalizadas do Polen em plataformas não integradas</p>
  </header>
  <section class="left-side-api card">
    <div class="form-group">
      <label>StoreUrl</label><br />
      <small>Na API v1, use este campo para a StoreId</small>
      <input class="form-control" type="text" name="storeSeoName" [(ngModel)]="profile.storeSeoName"
        #storeSeoName="ngModel" readonly />
    </div>
    <div class="form-group">
      <label> StoreId </label>
      <input class="form-control" type="text" name="storeId" [(ngModel)]="profile.storeId" #storeSeoName="ngModel"
        readonly />
    </div>
    <div class="form-group">
      <label> CompanyId </label>
      <input class="form-control" type="text" name="companyId" value="{{ companyId }}" readonly />
    </div>
  </section>
  <section class="right-side-api">
    <div class="form-group card">
      <label> Token </label><br>
      <small>É o api_token para autenticação com a API do Polen</small>
      <input class="form-control" type="text" name="accountApiToken" value="{{ accountApiToken }}" readonly />
    </div>
    <div class="form-group card documentation">
      <label> Documentação </label>
      <small>Existem métodos que precisam ser autorizados manualmente. Caso seja seu caso,
        por favor entre em contato conosco, clicando <a href="mailto:eupolinizo@opolen.com.br">aqui</a>.</small>
      <a class="api-btn" target="_blank" href="https://dev.polen.com.br/">dev.polen.com.br</a>
    </div>
  </section>
</main>